import React from "react";
import mainLogo from "../assets/img/main_logo.png";
import "../App.css";

const About = () => {
  return (
    <div className="about_page page_wrapper">
      <div className="about_top">
        <p className="about_intro">
          Luxe Sparkle is a New Zealand owned cleaning company based in Auckland
          delivering structured commercial and post-construction, cleaning
          services across Auckland and expanding into Whangārei.
        </p>
        <p>
          We specialise in commercial sites, education facilities, construction
          handovers and managed cleaning programmes. Our operations are
          supported by documented Standard Operating Procedures, digital
          reporting systems and Health and Safety compliance including Job
          Safety Analysis and site induction capability.
        </p>
        <p>
          From scheduling through completion and invoicing, our work follows
          defined systems built around accountability and communication. We
          operate with appropriate public liability insurance and contractor
          ready standards suitable for commercial and construction
          environments.
        </p>
        <p>
          Alongside our commercial services, we continue to support residential
          homes and Airbnb properties under the same
          structured delivery model.
        </p>
        <p>Structured service. Verified standards. Local accountability.</p>
        <img src={mainLogo} alt="Luxe Sparkle Logo" className="about_logo" />
      </div>

      <div className="map_section">
        <h3>Visit Us</h3>

        <div className="map_contact_info">
          <p>
            <strong>Address:</strong> 22 Mead Street, Avondale, Auckland 1026
          </p>
          <p>
            <strong>Phone:</strong> <a href="tel:092430470">09 243 0470</a>
          </p>
        </div>

        <iframe
          src="https://www.google.com/maps?q=22+Mead+Street,+Avondale,+Auckland+1026&output=embed"
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Luxe Sparkle Location"
        ></iframe>
      </div>
    </div>
  );
};

export default About;
